import React from 'react';

// This global object acts as "Live RAM". It never gets deleted as long as the tab is open!
const memoryCache = {};

export const useMemory = (key, defaultValue) => {
  const [value, setValue] = React.useState(() => {
    // 1. First, check the Live RAM (Survives React unmounting & the Back button)
    if (memoryCache[key] !== undefined) {
      return memoryCache[key];
    }
    
    // 2. Second, check LocalStorage (Survives hard page reloads & closed tabs)
    try {
      const saved = window.localStorage.getItem(key);
      if (saved !== null) {
        memoryCache[key] = JSON.parse(saved);
        return memoryCache[key];
      }
    } catch (error) {
      console.warn('Error reading localStorage', error);
    }
    
    // 3. Fallback to default
    memoryCache[key] = defaultValue;
    return defaultValue;
  });

  React.useEffect(() => {
    // Instantly sync every keystroke to both RAM and LocalStorage
    memoryCache[key] = value;
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn('Error setting localStorage', error);
    }
  }, [key, value]);

  return [value, setValue];
};

